<template>
  <TrainingContent />
</template>

<script>
import TrainingContent from '@/components/content/education/training/TrainingContent.vue'

export default {
  name: 'TrainingContentPage',
  components: { TrainingContent }
}
</script>

<style scoped>

</style>
